module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"btn_submit":"Получить код","placeholder_email":"Эл. почта"}}')
  delete Component.options._Ctor
}
